import axios from 'axios';

import { ImportResult } from '@/module/Sync/model/SyncTypes';

import { getData } from '@feature/utils';

export function getBibtexImportResult(file: File, year: number) {
  const data = new FormData();
  data.append('file', file);
  data.append('year', String(year));
  return axios
    .post<ImportResult>('/bibtex/sync', data, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    })
    .then(getData);
}

export function getScopusImportResult(year: number) {
  return axios
    .post<ImportResult>('/scopus/sync', undefined, {
      params: {
        year,
      },
    })
    .then(getData);
}
